import './SelectFilter.css';
import { useContext, useState } from "react";
import { FiltersContext } from "../../../../../assets/contexts/filtersContext";
import { CheckedIcon } from '../../../../../assets/icons/icons';
import { DropArrowIcon } from '../../../../../assets/icons/promoCatalog';
import { motion } from 'framer-motion';

function SelectFilter({ filter }) {
    const { setFilterValues } = useContext(FiltersContext);

    // Переключатель видимости списка значений
    const [isOpen, setIsOpen] = useState(false);

    const handleSelect = (value) => {
        setFilterValues((prevValue) =>
            prevValue.map((item) => {
                if (item._id !== filter._id) return item;
                else {
                    const item_prev_value = item.value ? item.value : [];
                    const is_value_selected = item_prev_value.indexOf(value) >= 0;
                    if (is_value_selected) {
                        // Убираем значение
                        const new_value = item_prev_value.filter((itm) => itm !== value);
                        return {
                            ...item,
                            value: new_value,
                        };
                    } else {
                        // Добавляем значение
                        const new_value = item_prev_value.concat([value]);
                        return {
                            ...item,
                            value: new_value,
                        };
                    }
                }
            })
        );
    };

    // Варианты анимации для div со списком значений
    const containerVariants = {
        open: {
            height: "auto",
            opacity: 1,
            transition: {
                duration: 0.3,
            },
        },
        closed: {
            height: 0,
            opacity: 0,
            transition: {
                duration: 0.3,
            },
        },
    };

    const values = filter.features.values;

    return (
        <div className='select-filter'>
            <button
                className='select-filter__heading'
                type='button'
                onClick={() => setIsOpen(!isOpen)}
            >
                <p className='select-filter__name'>{filter.name}</p>
                <DropArrowIcon mainClassName={'select-filter__arrow'} fillClassName={'select-filter__arrow-fill'} />
            </button>

            {/* Анимированное раскрытие/скрытие списка значений */}
            <motion.div
                className='select-filter__values'
                variants={containerVariants}
                initial="closed"
                animate={isOpen ? "open" : "closed"}
                style={{ overflow: "hidden" }} // чтобы при закрытии не было заметно, что элемент "выходит" за пределы контейнера
            >
                {values && values.length > 0 && [...values].sort((a, b) => `${a}`.localeCompare(`${b}`)).map((item, i) => (
                    <button
                        className='select-filter__value'
                        type='button'
                        key={`select-filter__value${filter._id}-${i}`}
                        onClick={() => handleSelect(item)}
                    >
                        <div className={`select-filter__value-checkbox ${filter.value &&
                                filter.value.length > 0 &&
                                filter.value.indexOf(item) >= 0
                                ? 'select-filter__value-checkbox_selected'
                                : ''
                            }`}
                        >
                            <CheckedIcon
                                mainClassName={'select-filter__value-checkbox-icon'}
                                strokeClassName={'select-filter__value-checkbox-icon-stroke'}
                            />
                        </div>
                        {item}
                    </button>
                ))}
            </motion.div>
        </div>
    );
}

export default SelectFilter;
